module.exports = __webpack_public_path__ + "static/media/logo.f25c0f7e.svg";